import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import {
  ACCOUNT_DEALS_ROUTE,
  ADD_AGENT_ROUTE,
  ADD_PROPERTY_ROUTE,
  CONTACTS_ROUTE,
  LEADS_ROUTE,
  PROPERTY_ROUTE,
  TASKS_ROUTE,
  TODAY_LEADS_ROUTE,
  INTEGRATION_ROUTE
} from "../../../constants/routes";
import {
  MdOutlinePictureAsPdf,
  MdOutlineContactPhone,
  MdRealEstateAgent,
  MdOutlineLeaderboard,
} from "react-icons/md";
import { FaTasks } from "react-icons/fa";
import { RiAddBoxFill } from "react-icons/ri";
import { IoPersonAddSharp } from "react-icons/io5";
import { LuListTodo } from "react-icons/lu";
import { SiHubspot } from "react-icons/si";

export const LINKS = [
  {
    title: "Dashboard",
    icon: DashboardOutlinedIcon,
    href: "/",
  },
  {
    title: "Properties",
    icon: MdRealEstateAgent,
    href: PROPERTY_ROUTE,
  },
  {
    title: "Add Property",
    icon: RiAddBoxFill,
    href: ADD_PROPERTY_ROUTE,
  },
  {
    title: "Leads",
    icon: MdOutlineLeaderboard,
    href: LEADS_ROUTE,
  },

  {
    title: "Tasks",
    icon: FaTasks,
    href: TASKS_ROUTE,
  },

  {
    title: "To-do Today",
    icon: LuListTodo,
    href: TODAY_LEADS_ROUTE,
  },

  {
    title: "Deals",
    icon: MdOutlinePictureAsPdf,
    href: ACCOUNT_DEALS_ROUTE,
  },
  {
    title: "Add Staff",
    icon: IoPersonAddSharp,
    href: ADD_AGENT_ROUTE,
  },
  {
    title: "Contacts",
    icon: MdOutlineContactPhone,
    href: CONTACTS_ROUTE,
  },
  {
    title: "Integration Hub",
    icon: SiHubspot,
    href: INTEGRATION_ROUTE,
  },
];

export const ACCOUNTS_OPTIONS = [
  {
    title: "Deals",
    icon: MdOutlinePictureAsPdf,
    href: ACCOUNT_DEALS_ROUTE,
  },
  // {
  //   title: "Total Income",
  //   icon: IoMdArrowDropright,
  //   href: ACCOUNT_INCOME_ROUTE ,
  // },
];
